import React from 'react';
import { Company } from '../../../../../types/company';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { t } from '../../../../../types/translation/Translator';
import { FeatureToggleItem, FeatureToggleTitle, FeatureToggleExplanation, FeatureToggleInformation } from '../common';

interface QuickActionFeatureTogglesViewProps {
  company: Company;
  update: (company: Company) => Promise<void>;
}

export default function QuickActionFeatureTogglesView({ company, update }: QuickActionFeatureTogglesViewProps) {
  const copy = new Company(company);
  const toggle = copy.settings.featureToggles.productTransactions.quickActions;

  return (
    <FeatureToggleItem
      solo
      value={toggle}
      onChange={async value => await update(copy.withQuickActionsProductTransactionFeatureToggle(value))}
    >
      <FeatureToggleTitle text={t(TranslationKey.quickActionQuickActionFeatureToggleTitle).singular.upper} />
      <FeatureToggleExplanation
        text={t(TranslationKey.quickActionQuickActionFeatureToggleExplanation).singular.upper}
      />
      <FeatureToggleInformation
        text={t(TranslationKey.quickActionQuickActionFeatureToggleInformation).singular.upper}
      />
    </FeatureToggleItem>
  );
}
